import { convertToRaw, EditorState } from 'draft-js';

import React, { useEffect, useState } from 'react';
import Editor from 'react-simple-code-editor';
// @ts-ignore
import { highlight, languages } from 'prismjs/components/prism-core';
import 'prismjs/components/prism-clike';
import 'prismjs/components/prism-javascript';
import './prism-okaidia.css';
import Button from '@mui/material/Button';
import { html as beautifyHtml } from 'js-beautify';
import { useTranslation } from 'react-i18next';
import Dialog, { DialogProps } from '@mui/material/Dialog';
import { makeStyles } from '@mui/styles';
import Grid from '@mui/material/Grid';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import { draftToHtml } from '../index';

interface IProps {
  maxWidth?: DialogProps['maxWidth'];
  onCancel: () => void;
  onSubmit: (tempHtml: string) => void;
  visible: boolean;
  editorState: EditorState;
}

const useStyles = makeStyles((theme) => ({
  editor: {
    overflow: 'auto',
    height: '70vh',
    '&>div': {
      overflow: 'auto !important',
    },
  },
}));

export default function ModalEditCode(props: IProps) {
  const { editorState, visible, onCancel, maxWidth, onSubmit } = props;
  const { t } = useTranslation();
  const classes = useStyles();
  const [html, setHtml] = useState<string>('');

  useEffect(() => {
    const raw = convertToRaw(editorState.getCurrentContent());
    setHtml(beautifyHtml(draftToHtml(raw)));
  }, []);

  return (
    <Dialog open={visible} onClose={onCancel} maxWidth={maxWidth} fullWidth>
      <DialogTitle>{t('edit')}</DialogTitle>
      <DialogContent>
        <Grid container item justifyContent="flex-end" spacing={1}>
          <Grid item xs={12}>
            <div className={classes.editor} id="react-simple-code-editor">
              <Editor
                value={html}
                onValueChange={(value) => setHtml(value)}
                highlight={(code) => highlight(code, languages.js)}
                padding={10}
                style={{
                  fontFamily: '"Fira code", "Fira Mono", monospace',
                  fontSize: 14,
                  height: '100%',
                  backgroundColor: '#272822',
                  caretColor: 'white',
                }}
              />
            </div>
          </Grid>
          <Grid container item justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                color="primary"
                onClick={() => {
                  onCancel();
                }}
              >
                {t('close')}
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  let tempHtml = html;
                  // Add empty P tag prevent draft js broken
                  if (!tempHtml.startsWith('<p></p>')) {
                    tempHtml = `<p></p>${tempHtml}`;
                  }

                  if (!tempHtml.endsWith('<p></p>')) {
                    tempHtml += '<p></p>';
                  }
                  onSubmit(tempHtml);
                }}
              >
                {t('save')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
}
